import { ApplicationRef, createComponent, DestroyRef, inject, Service } from '@angular/core';
import { MessagesComponent } from './messages.component';

@Service()
export class MessagesService {
    private readonly applicationRef = inject(ApplicationRef);
    private readonly destroyRef = inject(DestroyRef);

    constructor() {
        const messagesComponentRef = createComponent(MessagesComponent, {
            environmentInjector: this.applicationRef.injector,
        });

        this.applicationRef.attachView(messagesComponentRef.hostView);
        document.body.appendChild(messagesComponentRef.location.nativeElement);

        this.destroyRef.onDestroy(() => {
            this.applicationRef.detachView(messagesComponentRef.hostView);
            messagesComponentRef.destroy();
        });
    }
}
